import APICom from "./APICom";
import moment from 'moment';

class CommonFunctions {
    
    static async checkAutoRouting(TempAff, _req_date, GlobalASCSData) {
        let _result = GlobalASCSData.filter((v) => String(v.AffiliateID) == String(TempAff));
        let isDateInSevenDays = true;
        try {
            let _today_date = moment();
            _today_date = _today_date.add(6, 'days');
            let _requested_date = moment(_req_date);
            if (_requested_date.isSameOrBefore(_today_date.add(6, 'days'), 'day')) {
                isDateInSevenDays = true;
            } else {
                isDateInSevenDays = false;
            }
        } catch (e) {
            console.log("error isDateInSevenDays :" + e);
        }
        let bStopped = false;
        //TempAff="28";
        if (isDateInSevenDays) {
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/ARBProcessStatus?AffiliateID=" + TempAff + "&ReqDate=" + "1/1/1900", "get", { "Content-Type": "application/json" }, null, null);
            let data = response.data;
            let _requested_date = moment(_req_date);
            for (let i = 0; i < data.length; i++) {
                if (_requested_date.isSame(data[i].dtServiceDate, 'day')) {
                    bStopped = true;
                    break;
                }
            }
        }
        let returnResult = false;
        if (_result.length > 0 && _result[0].bAutoRoutingEnabled === true && isDateInSevenDays === true && bStopped === true) {
            let response =  await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/ARBProcessStatus?AffiliateID=" + TempAff + "&ReqDate=" + _req_date, "get", { "Content-Type": "application/json" }, null, null);
            let data = response.data;
            if (data.length > 0 && data[0].iPauseAutoRouting === 0) {
                returnResult = true;
            }
            else {
                returnResult = false;
            }
        }
        else {
            returnResult = false;
        }
        return returnResult;
    }
    static ParseFormatADate(datetimeobj){
        // Input date string
        let dateString = datetimeobj;

        // Split the string into date and time parts
        let [datePart, timePart] = dateString.split(' ');

        // Split the date part into day, month, and year
        let [month, day, year] = datePart.split('/');

        // Split the time part into hours, minutes, and AM/PM
        let [time, period] = timePart.split(/([0-9]+:[0-9]+)([A-Za-z]+)/).filter(Boolean);

        // Convert 12-hour time to 24-hour time
        let [hours, minutes] = time.split(':');
        if (period.toUpperCase() === 'PM') {
            hours = (parseInt(hours, 10) % 12) + 12;
        }

        // Create a new Date object
        return new Date(year, month - 1, day, hours, minutes);
    }
    static isDateWithin30Minutes(date){
        // Get the current date and time
        const currentDate = new Date();
      
        // Calculate the difference in milliseconds between the given date and the current date
        const timeDifference = date.getTime() - currentDate.getTime();
      
        // Convert the time difference to minutes
        const minutesDifference = timeDifference / (1000 * 60);
      
        // Check if the absolute value of the minutes difference is less than or equal to 30
        return Math.abs(minutesDifference) <= 30;
    }
    static isDateWithinFuture30Minutes(date){
        // Get the current date and time
        const currentDate = new Date();
      
        // Calculate the difference in milliseconds between the given date and the current date
        const timeDifference = date.getTime() - currentDate.getTime();
      
        // Convert the time difference to minutes
        const minutesDifference = timeDifference / (1000 * 60);
      
        // Check if the absolute value of the minutes difference is less than or equal to 30
        return minutesDifference <= 30;
    }
    static async SaveRBSStatus (iPauseAutoRouting, dtServiceDate, affilateId, user_id, iActionSource = 0) {
        try {
/*
        var myData = "api/Routing/StartStopProcess?iAffiliateID=" + affilateId + "&dtServiceDate=" + dtServiceDate + "&iPauseAutoRouting=" + iPauseAutoRouting + "&iActionSource=" + iActionSource + "&iUserID=" + user_id;
        sessionStorage.setItem('ARBProcessStatus', myData);
        */
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/StartStopProcess?iAffiliateID=" + affilateId + "&dtServiceDate=" + dtServiceDate + "&iPauseAutoRouting=" + iPauseAutoRouting + "&iActionSource=" + iActionSource + "&iUserID=" + user_id, "post", { "Content-Type": "application/json" }, null, null);
            
        } catch (ex) {
            console.log(ex);
        }
    }

    static PopulateCombineData = async(e) => {
        let response = ""
        try {
            let vUserAssignedAffiliates = "-1";
            response = await APICom.fetchData("AspDotNetCoreURL", "CombinedData/GetCombinedDataByAffiliateIDs?vAffiliateIds=" + vUserAssignedAffiliates, "get", {}, {});
            response = JSON.parse(response.data);
            return response;
        }
        catch(e){console.log(e);}
        return response;
    };
};

export default CommonFunctions;